import { render, staticRenderFns } from "./SelectRepartidor.vue?vue&type=template&id=c3209334&"
import script from "./SelectRepartidor.vue?vue&type=script&lang=js&"
export * from "./SelectRepartidor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports